import Backbone from 'backbone'
import _ from 'lodash'

/**
 * Triggers either add:domain-object or edit:domain-object. Handles some common
 * situations like passing the relativeId to add:domain-object and leaving it
 * out for edit:domain-object
 */
function triggerAddOrEdit (eventName, model, options = {}) {
	if (eventName === 'add') {
		let relativeId = _.isNil(options?.relativeId)
			? model.get('relativeId') : options.relativeId

		triggerAdd(model, relativeId, options)
	} else if (eventName === 'edit') {
		triggerEdit(model, options)
	}
}

function triggerAdd (model, relativeId, options = {}) {
	Backbone.trigger('add:domain-object', model, relativeId, options)
}

function triggerEdit (model, options = {}) {
	Backbone.trigger('edit:domain-object', model, options)
}

export { triggerAddOrEdit, triggerAdd, triggerEdit }
